import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@/locales/en.json";
import es from "@/locales/es.json";

// Convención de keys (ADR-126): "{page}.{elemento}" en minúsculas con puntos,
// ej. "settings.security.changePassword". Namespace único "translation".
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "raise-admin-language",
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
